import React, { useState, useEffect, useRef } from 'react';
import clsx from 'clsx';
import style from './style.module.scss';
import SoccerTimeLineStore from './store';
import SoccerTimeLineItem from './item';

const SoccerTimeLine = ({
  isOpen,
  item,
  timeLineOpenButtonRef,
  toggleOpenTimeLine,
  isBottom
}) => {
  const timeLineRef = useRef();
  const { id } = item;
  const { home, away } = item.getTeamData;
  const [isShow, toggleShow] = useState(false);
  const { getBrodcasts, timeLine } = SoccerTimeLineStore();

  useEffect(() => {
    if (isOpen) {
      getBrodcasts(id);
      toggleShow(true);
    } else {
      toggleShow(false);
      toggleOpenTimeLine(false);
    }
  }, [isOpen]);

  const onClick = (event) => {
    if (timeLineRef.current && !timeLineRef.current.contains(event.target)) {
      if (
        timeLineOpenButtonRef.current &&
        !timeLineOpenButtonRef.current.contains(event.target)
      ) {
        toggleShow(false);
        toggleOpenTimeLine(false);
      }
    }
  };

  useEffect(() => {
    document.addEventListener('click', onClick, true);
    return () => {
      document.removeEventListener('click', onClick, true);
    };
  }, []);

  if (isShow) {
    return (
      <div
        className={clsx(style.event_board, isBottom ? style.bottom : style.top)}
        ref={timeLineRef}
      >
        <div className={style.hd}>
          <span className={style.team}>{home.name}</span>
          <span className={style.event}>VS</span>
          <span className={style.team}>{away.name}</span>
        </div>

        <div className={style.bd}>
          {timeLine.length > 0 &&
            timeLine.map((item, idx) => (
              <SoccerTimeLineItem
                key={`${item.displayTime.split(':').join('')}${idx}${id}`}
                item={item}
              />
            ))}
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default SoccerTimeLine;
